import * as React from 'react';
import { cn } from '@/hen-ui/utils/cn';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Text } from '@/hen-ui/atomics/Text';

export type StickyColumnProps = {
  heading: string;
  description: string;
  className?: string;
  children: React.ReactNode;
};

export const StickyColumn = React.forwardRef<HTMLDivElement, StickyColumnProps>(
  ({ heading, description, className, children }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col md:flex-row md:items-start gap-3xl w-full',
          className,
        )}
      >
        {(heading || description) && (
          <div className='w-full md:w-1/2 md:sticky md:self-start top-16 md:top-24'>
            <div className='flex flex-col gap-sm md:py-page-top'>
              {/* TODO: Discuss with both creative and SEO team on how to handle the heading structure for this component. Will modify once this is clarified */}
              {heading && <Heading variant='h1'>{heading}</Heading>}
              {description && <Text variant='b3'>{description}</Text>}
            </div>
          </div>
        )}
        <div className='w-full text-left md:w-1/2'>{children}</div>
      </div>
    );
  },
);

StickyColumn.displayName = 'StickyColumn';
